<template>
<div>
    <v-head :title="title"></v-head>
    <div class="goodCont">
        <div class="titleCont"><h1>{{base.title}}</h1></div>
        <div class="nameCont"><span>发布人：{{base.name}}</span> <span>发布时间：{{base.auditTime| limitDate}}</span></div>
        <div class="contentT" v-html="base.content">{{base.content}}</div>
    </div>
</div>
</template>

<script>
import {Toast} from 'vant';
import vHead from "../../components/Subhead.vue";
import {MemberStyleDetails} from "@/api/dictionary";
export default {
  data() {
    return {
        base:[],
        title:"详情",
    };
  },
  components: {
      vHead,
    [Toast.name]:Toast
  },
  methods: {
      detail(id){
          MemberStyleDetails({id:id}).then(res=>{
              if(res.success){
                  this.base = res.result;
              }else {
                  Toast.fail("获取数据错误!");
                  this.$router.push({name:"memberStyle"})
              }
          });
      }
  },
  computed: {
      id(){
          return this.$route&&this.$route.query.id;
      }
  },
  mounted() {
      this.detail(this.id);
  }
}
</script>
<style scoped lang="less">
    .titleCont h1{ font-size: 22px; font-weight: bold; text-align: center; }
    .goodCont{ margin-top: 10px; padding: 15px; font-size:14px;}
    .nameCont{ text-align: center; font-size:14px; margin-top: 20px; }
    .nameCont span{ margin: 0 10px; font-size: 12px; }
    .contentT{ margin-top: 20px; line-height: 24px; font-size: 14px;}
</style>